import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoginMessages from '../components/Login/LoginMessages';
import { changePassword } from '../actions/loginActions';
import ChangePasswordSuccess from './ChangePasswordSuccess';
import ShowEye from './ShowEye';
import HideEye from './HideEye';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hiddenPassword: true,
      hiddenNewPassword: true,
      hiddenConfirmPassword: true,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      errors: '',
      isChangePasswordSuccess: false,
    };
  }

  noSpaces = e => {
    if (e.target.value.match(/\s/g)) {
      e.target.value = e.target.value.replace(/\s/g, '');
    }
  }

  handlePasswordChange = e => {
    this.noSpaces(e);
    this.setState({
      oldPassword: e.target.value,
    });
  };

  handleNewPasswordChange = e => {
    this.noSpaces(e);
    this.setState({
      newPassword: e.target.value,
    });
  };

  handleConfirmPasswordChange = e => {
    this.noSpaces(e);
    this.setState({
      confirmPassword: e.target.value,
    });
  };

  toggleShowPassword = () => {
    this.setState(prevState => ({
      hiddenPassword: !prevState.hiddenPassword,
    }));
  };

  toggleShownewPassword = () => {
    this.setState(prevState => ({
      hiddenNewPassword: !prevState.hiddenNewPassword,
    }));
  };

  toggleShowConfirmPassword = () => {
    this.setState(prevState => ({
      hiddenConfirmPassword: !prevState.hiddenConfirmPassword,
    }));
  };

  handleChangePassword = e => {
    e.preventDefault();
    const isValidate = this.validatePassword(
      this.props.loginResponse.data.username,
      this.state.confirmPassword
    );
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ errors: { message: LoginMessages.ERROR.MSG_6 } });
    } else if (isValidate) {
      this.setState(prevState =>
        ({ errors: '', password: prevState.confirmPassword }),
        () => {
          changePassword(
            this.props.loginResponse.data.username,
            this.state.oldPassword,
            this.state.confirmPassword,
          ).then(response => {
            const { error, message, statusCode } = response;
            if (error && statusCode === 400) {
              this.setState({ errors: { message } });
            } else {
              this.setState({
                isChangePasswordSuccess: response,
              });
            }
          });
        }
      );
    }
  };

  validatePassword = (username, password) => {
    let validPassword = true;
    if (password === '' || password === username) {
      validPassword = false;
    }
    if (this.state.oldPassword === this.state.confirmPassword) {
      validPassword = false;
    } else {
      const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[A-Z$@$!%*^#?&_])[A-Za-z\d$@$!%*^#?&_]{8,}$/;
      if (!passwordPattern.test(password)) {
        validPassword = false;
      }
    }
    if (!validPassword) {
      this.setState({ errors: { message: LoginMessages.ERROR.MSG_7 } });
      return false;
    }
    return true;
  };

  render() {
    if (this.state.isChangePasswordSuccess) {
      return <ChangePasswordSuccess />;
    }
    return (
      <div className="change-password">
        <div className="change-password-card">
          <div className="change-password-body">
            <h3>Change Password</h3>
            {this.state.errors &&
              <div className="error text-left padding-left-0 margin-bottom-10">{this.state.errors.message}</div>}

            <div className="form-input">
              <label htmlFor="password">Confirm your current password</label>
              <div className="form-input-eye">
                <input
                  type={this.state.hiddenPassword ? 'password' : 'text'}
                  value={this.state.oldPassword}
                  onChange={this.handlePasswordChange}
                  placeholder="Current password"
                  id="password"
                  name="password"
                  className="form-control"
                />
                <button
                  type="button"
                  title={this.state.hiddenPassword ? 'Show' : 'Hide'}
                  className="hide-show-btn"
                  onClick={this.toggleShowPassword}>
                  {this.state.hiddenPassword ? <ShowEye /> : <HideEye />}
                </button>
              </div>
            </div>
            <div className="form-input">
              <label htmlFor="newPassword">Enter your new password</label>
              <div className="form-input-eye">
                <input
                  type={this.state.hiddenNewPassword ? 'password' : 'text'}
                  value={this.state.newPassword}
                  onChange={this.handleNewPasswordChange}
                  placeholder="New password"
                  id="newPassword"
                  name="newPassword"
                  className="form-control"
                />
                <button
                  type="button"
                  title={this.state.hiddenNewPassword ? 'Show' : 'Hide'}
                  className="hide-show-btn" onClick={this.toggleShownewPassword}
                >
                  {this.state.hiddenNewPassword ? <ShowEye /> : <HideEye />}
                </button>
              </div>
            </div>
            <div className="form-input last">
              <div className="form-input-eye">
                <input
                  type={this.state.hiddenConfirmPassword ? 'password' : 'text'}
                  value={this.state.confirmPassword}
                  onChange={this.handleConfirmPasswordChange}
                  placeholder="Confirm new password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-control"
                />
                <button
                  type="button"
                  title={this.state.hiddenConfirmPassword ? 'Show' : 'Hide'}
                  className="hide-show-btn" onClick={this.toggleShowConfirmPassword}
                >
                  {this.state.hiddenConfirmPassword ? <ShowEye /> : <HideEye />}
                </button>
              </div>
            </div>
            <button
              onClick={this.handleChangePassword}
              className="button"
              type="submit"
            >
              Change Password
            </button>
            <div className="password-requirement">
              <h5>Password Requirements</h5>
              <ul>
                <li>At least 8 characters</li>
                <li>Contain at least 3 of the following 4 types of characters</li>
                <li>
                  <ul>
                    <li>Lower case letter (a-z)</li>
                    <li>Upper case letter (A-Z)</li>
                    <li>Numbers (i.e., 0-9)</li>
                    <li>Special characters (e.g. !@#$%^&amp;*)</li>
                  </ul>
                </li>
                <li>Cannot match any of the 3 passwords previously used</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      username: PropTypes.string,
    })
  })
}

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
  };
}

/* function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
  };
} */

export default connect(
  mapStateToProps,
  {},
)(ChangePassword);
